<div appAccessProvider
    [accessCode]="{menuCode: 'SETTINGS', subMenuCode: 'GENERAL_SETTING', pageCode: 'NOTIFICATION_AND_EMAIL', subPageCode: 'EDIT' }">
    <div class="flex justify-content-end flex-wrap btn-with-links">
        <button pButton class="mr-2 bg-white default-text-light-black-color cursor-pointer border-button"
            [label]="'cancel' | translate" (click)="onCancel()"></button>
        <p-button class="flex align-items-center justify-content-center cursor-pointer event-box"
            (click)="onNextBtnClick()" [label]="saveNotificationSettings"></p-button>
    </div>

    <p-tabView [(activeIndex)]="activeIndex">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="tab-icons">
                    <i class="mi-lg details mr-2"></i>
                    <span translate>settings.lbl_notification_email_settings</span>
                </div>
            </ng-template>
            @for(tab of notificationData?.tabs; track tab?.tabCode) {
            @if (showForm) {
                <app-mi-form
                    [attributeLabels]=" attributeLabels "
                    [moduleName]="exportGeneralSettingsModuleName"
                    [attributeValues]="attributeValues"
                    [groups]="tab.groups"
                    [isMultipleFilesUpload]="false"
                    [previousBtnText]="previousBtnLabel"
                    [submitBtnText]="saveExportSettingsBtnLabel"
                    (saveData)="saveNoticationSettings($event)"
                    [saveBtnId]="'notification'"
                    [displaySubmitButtons]="true"
                    [submitBtnText]="saveNotificationSettings"
                    (previousClick)="onCancel()"
                    [isTwoColStructure]="true"
                >   
                </app-mi-form>
            }

            }

        </p-tabPanel>
    </p-tabView>
</div>